 	// install a JSONP callback for chunk loading
 	var parentJsonpFunction = window["webWeddingJsonpFunction"];
 	window["webWeddingJsonpFunction"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [], result;
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
 		while(resolves.length) {
 			resolves.shift()();
 		}
 		if(executeModules) {
 			for(i=0; i < executeModules.length; i++) {
 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
 			}
 		}
 		return result;
 	};

 	// The module cache
 	var installedModules = {};

 	// objects to store loaded and loading chunks
 	var installedChunks = {
 		63: 0
 	};

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData === 0) {
 			return new Promise(function(resolve) { resolve(); });
 		}

 		// a Promise means "currently loading".
 		if(installedChunkData) {
 			return installedChunkData[2];
 		}

 		// setup Promise in chunk cache
 		var promise = new Promise(function(resolve, reject) {
 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
 		});
 		installedChunkData[2] = promise;

 		// start chunk loading
 		var head = document.getElementsByTagName('head')[0];
 		var script = document.createElement('script');
 		script.type = 'text/javascript';
 		script.charset = 'utf-8';
 		script.async = true;
 		script.timeout = 120000;

 		if (__webpack_require__.nc) {
 			script.setAttribute("nonce", __webpack_require__.nc);
 		}
 		script.src = __webpack_require__.p + "static/js/" + ({"0":"CollectAddressV2","1":"CardListingPage","2":"CardDetailPage","3":"EventDetailWrite","4":"DigitalPreviewPage","5":"EventDetailFrontV2","6":"Addressing","7":"EventDetailInsideV2","8":"EventDetailBackV2","9":"VirtualEventOverview","10":"DashboardContainer","11":"OnboardContainer","12":"InvitationsLandingContainerV2","13":"Events","14":"ManagePagesRedesign","15":"EnvelopeV2","16":"RsvpEnvelopeV2","17":"ThemeDetail","18":"CardCustomizationFlowV2","19":"Review","20":"Website","21":"PublicDigitalCard","22":"VirtualEvents","23":"Pages","24":"Recipients","25":"ProjectDrafts","27":"Virtual","28":"Guests","29":"RSVPV2","30":"Stories","31":"CollectInfo","32":"ProjectOrders","33":"GuestsV2","34":"SeatingList","35":"DigitalReview","36":"DigitalCard","37":"ThemesContainerV2","38":"CardProjects","39":"AccountSettings","40":"VirtualEmbed","41":"Public","43":"GuestHelp","45":"ZoomMeetingOver","46":"Cards","47":"DigitalCompletion","48":"Passcode","49":"Manage","50":"ucare-widget-chunk","51":"ucare-panel-chunk","52":"TrackRsvpsContainer","54":"Onboard","56":"main"}[chunkId]||chunkId) + "." + {"0":"7db8d0dd","1":"9bc9f3ea","2":"e10d8eb9","3":"eb286c2b","4":"4b92b126","5":"dc0f5596","6":"95275dcc","7":"a0a27175","8":"eb0ada0f","9":"acaa84c3","10":"66f08417","11":"1afa5158","12":"6730a89e","13":"d87d8de7","14":"6d496ea6","15":"97f063c2","16":"476408b7","17":"c04c3732","18":"19be897c","19":"b5b53fed","20":"252c3b7f","21":"a42ef49d","22":"8245e42c","23":"41bb90d6","24":"491e7e92","25":"5454aab2","26":"7f682445","27":"c8121cf9","28":"9d78a5e8","29":"17d93d44","30":"a9e73d52","31":"e02e4d10","32":"9776362e","33":"bc88a390","34":"28206b55","35":"13edca22","36":"21a82fd7","37":"f817b969","38":"3b57e9bf","39":"cf70d5d7","40":"06b87f75","41":"bf382c47","42":"ad8bc246","43":"8705fb8c","44":"4bc95e23","45":"6cecba45","46":"06ed1de5","47":"9a15434a","48":"483af7a1","49":"8ce97922","50":"86bcf4ea","51":"69f6bfe5","52":"c24ad0bb","53":"3c891d0e","54":"adea258a","55":"856b396d","56":"9ea93258","57":"058ecb1a","58":"7790dc50","59":"2b5b2a30","60":"f4937749","61":"3926f159","62":"2bcbc291"}[chunkId] + ".chunk.js";
 		var timeout = setTimeout(onScriptComplete, 120000);
 		script.onerror = script.onload = onScriptComplete;
 		function onScriptComplete() {
 			// avoid mem leaks in IE.
 			script.onerror = script.onload = null;
 			clearTimeout(timeout);
 			var chunk = installedChunks[chunkId];
 			if(chunk !== 0) {
 				if(chunk) {
 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
 				}
 				installedChunks[chunkId] = undefined;
 			}
 		};
 		head.appendChild(script);

 		return promise;
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };



// WEBPACK FOOTER //
// webpack/bootstrap 19513fee606218927484